<app-common-title *ngIf="options.titleOptions" [options]="options.titleOptions"></app-common-title>
<div class="search-container">
    <button type="button" class="btn btn-light back-action" [routerLink]="options.backRouterLink">
        <fa-icon [icon]="faCaretLeft"></fa-icon> {{ 'shared.backBtn' | translate }}
    </button>
    <div class="selected-actions search-box">
        <ng-container *ngIf="options.searchOptions">
            <input class="form-control" [placeholder]="options.searchOptions.placeholder | translate" type="text" class="form-control" [(ngModel)]="searchModel" (input)="itemInput()" (keydown)="keyDownFunction($event)"/>
            <fa-icon *ngIf="searchModel" [icon]="faTimes" class="search-close clickable" (click)="removeSearchText()"></fa-icon>
        </ng-container>
        <ng-container *ngIf="options.openedObject && options.openedObject.response">
            <div class="details-title d-none d-sm-block">
                {{options.openedObject.response[options.openedObject.name]}} <fa-icon *ngIf="options.openedObject.response.isActive === false" [icon]="faMoon"></fa-icon>
            </div>
        </ng-container>
    </div>
    <ng-container *ngIf="options.editButton">
        <button type="button" class="btn btn-primary add-action" [routerLink]="options.editButton.routerLink">
            <fa-icon [icon]="faPencil"></fa-icon> {{ options.editButton.title | translate }}
        </button>
    </ng-container>
    <ng-container *ngIf="options.newButton">
        <ng-container *ngxPermissionsOnly="options.newButton.permissions">
            <button type="button" class="btn btn-success add-action" [routerLink]="options.newButton.routerLink">
                <fa-icon [icon]="faPlus"></fa-icon> {{ 'shared.addNewBtn' | translate }}
            </button>
        </ng-container>
    </ng-container>
    <ng-content></ng-content>
</div>
